import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import Modal from 'boron/FadeModal'
import { Link, browserHistory } from 'react-router'
import { api, host, domen } from '../config.js'
import CSSModules from 'react-css-modules'
import styles from './profileConfirmeEmail.css'
import LogoLink from '../components/componentKit/LogoLink'
import {Helmet} from "react-helmet";
import LoadingView from '../components/componentKit/LoadingView'


let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const defaultBg = <img className={styles.alfaBg} src="/assets/img/els/els-bg2.jpg" alt=""/>

class ProfileConfirmeEmail extends Component {
  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.width = '300px'
    }

    const token = this.props.location.query.token
    if(token){
      this.setState({
        loading:true
      })
    }
  }

  state = {
    resultText:'',
    loading: false
  }

  componentDidMount(){
    const token = this.props.location.query.token

    if(token){
      const payload = {
        token
      }
      return fetch(`${api}/user/user-confirmEmail`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(json => {
          if (json.data) {
            if (json.data.resultCode === 1) {
              this.setState({
                resultText: 'Почта подтверждена',
                loading: false
              })
            } else {
              this.setState({
                resultText:json.data.resultText,
                loading: false
              })
            }
          } else {
            this.setState({
              resultText:'Ошибка сервера',
              loading: false
            })
          }

        })
    }
  }

  render() {
    const { sign } = this.props
    const  isAlfa = domen.isAlfa
    const  isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let bg = defaultBg
    if (this.state.loading) {
      return (<LoadingView title="Загружается..."/>)
    }

    return (
      <div>
        <Helmet>
          <link rel="stylesheet" href="/assets/css/unipro.css" />
        </Helmet>
        <img role="presentation" id="svg-inject-me" className={styles.injectedSvg} src="assets/img/symbol-sprite.svg" alt/>
        <div className={styles.layoutEntry}>
          <div className={styles.gridEntryHeader}>
            <div className={styles.gridCellTodaymeLogo}>
              <LogoLink isUnipro={isUnipro} isAlfa={isAlfa}/>
            </div>
          </div>

          <div className={styles.entryMin}>
            <div className={styles.entryInner}>

              <div className={styles.entryHeader}>
                <h2 className={isAlfa ? styles.entryTitleCenterAlfa : styles.entryTitleCenter}>Подтверждение почты</h2>
              </div>


                <div className={styles.entryBox}>
                  {!this.state.resultText ?
                    <div>
                      <p>Хочешь увидеть что будет дальше?</p>
                      <p>Загляни в почту, адрес которой ты указал при регистрации, и пройди по ссылке из письма, которое мы тебе отправили.</p>
                      <p>После этого твоя регистрация будет завершена, и ты сможешь увидеть свой Личный кабинет.</p>
                      <Link className={styles.entryNavLink} to="/confirme/email">Повторно получить письмо</Link>
                      <Link className={styles.entryNavLink} to="/">Вход в кабинет</Link>
                    </div>
                    :
                    <div>
                      <div className={styles.center}>{this.state.resultText}</div>
                      {this.state.resultText !== 'Почта подтверждена' ?
                        <Link className={styles.entryNavLink} to="/confirme/email">Повторно получить письмо</Link>
                        : null
                      }
                      <Link className={styles.entryNavLink} to="/">Вход в кабинет</Link>
                    </div>
                  }
                </div>

            </div>
          </div>

          <div className={styles.entryBg}>
            {bg}
          </div>
        </div>
        <Modal ref='loadingModal' contentStyle={contentStyle} backdrop={false}>
          <div className={styles.entryHeader}>
            <h2 className={styles.entryTitleCenter}>Загружается...</h2>
          </div>
          <div className={styles.textCenter}>
            <div className={styles.loaderMain}></div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  program: state.profile.program,
  amount: state.profile.amount,
  packageType: state.profile.packageType
})

ProfileConfirmeEmail = connect(
  mapStateToProps,
)(ProfileConfirmeEmail)

export default CSSModules(ProfileConfirmeEmail, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/containers/ProfileConfirmeEmail.js